<template>
  <div class="call-log-detail">
    <Modal
      v-model="modalView"
      title="查看详情"
      @on-visible-change="changeVisible"
      width="750"
      :mask-closable="false"
      class="call-log-detail-modal"
    >
      <div class="form-detail">
        <div class="detail-item">
          <label class="detail-item-label">用户ID：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.userId"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">操作账号：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.userRealname"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">IP地址：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.requestIp"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">服务：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.service"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">调用时间：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.createTime"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">耗时：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.callDuration"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">请求方法：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.requestUri"></tooltip-card>
          </div>
        </div>
        <div class="detail-item">
          <label class="detail-item-label">请求类型：</label>
          <div class="detail-item-content">
            <tooltip-card :text="propForm.requestMethod"></tooltip-card>
          </div>
        </div>
        <div class="detail-item w100">
          <label class="detail-item-label">请求参数：</label>
          <div class="detail-item-content detail-item-border">
            {{ propForm.requestParams }}
          </div>
        </div>
        <div class="detail-item w100">
          <label class="detail-item-label">请求结果：</label>
          <div class="detail-item-content">
            <div
              :class="
                `circle_dot ${
                  propForm.requestResult == '成功'
                    ? 'circle_success'
                    : 'circle_off'
                }`
              "
            ></div>
            <span>{{ propForm.requestResult }}</span>
          </div>
        </div>
        <div class="detail-item w100" v-if="propForm.requestResult == '失败'">
          <label class="detail-item-label">日志：</label>
          <div class="detail-item-content detail-item-log">
            {{ propForm.requestLog }}
          </div>
        </div>
      </div>
      <div slot="footer" class="call-log-detail-modal-footer">
        <Button class="mr-12 w104px" shape="circle" @click="cancle"
          >返回</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import tooltipCard from "@/components/card/tooltip-card.vue";

export default {
  props: {
    propForm: Object,
  },
  components: {
    tooltipCard,
  },
  data() {
    return {
      modalView: false,
    };
  },
  created() {
    this.modalView = true;
  },
  methods: {
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      if (!val) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss">
.call-log-detail-modal {
  &-footer {
    text-align: right;
  }
  .form-detail {
    display: flex;
    flex-wrap: wrap;
    .detail-item {
      width: 50%;
      display: flex;
      margin-bottom: 24px;
      &-label {
        width: 5em;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #67799c;
        line-height: 19px;
        flex-shrink: 0;
        text-align: right;
      }
      &-content {
        flex: 1;
        max-width: 280px;
        color: #2f4061;
        display: flex;
        align-items: center;
      }
      &-border {
        max-width: 100%;
        height: 154px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        overflow: auto;
        align-items: flex-start;
        padding: 10px;
      }
      &-log {
        max-width: 100%;
        background-color: #2f4061;
        height: 226px;
        border-radius: 4px;
        overflow: auto;
        color: #fff;
        align-items: flex-start;
        padding: 10px;
      }
    }
    .w100 {
      width: 100%;
    }
  }
}
</style>
